import index from "./v5Report.vue";
export default index;
